import { SxProps } from '@mui/material';
import { CSSProperties } from 'react';
import { black1, yellow, yellow1 } from 'app/components/ThemeProvider/colors';
import { getTheme } from '../ThemeProvider/theme';

const theme = getTheme('light');
export const sidebarMenuBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  width: '26%',
  borderRight: '1px solid rgba(20, 25, 31, 0.06)',
  p: '40px 30px 44px 28px',
  alignItems: 'space-between',
  height: 'calc(100vh - 110px)',
  overflow: 'auto',

  [theme.breakpoints.down('md')]: {
    p: '0px 20px 0px 20px',
    mt: '29px',
    width: '100%',
  },
};

export const links: CSSProperties = {
  fontFamily: 'Yelo',
  fontSize: '18px',
  fontWeight: '600',
  textDecoration: 'none',
  color: black1,
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
  padding: '12px 12px 12px 20px',
};

export const activeLink: CSSProperties = {
  background: yellow,
  borderRadius: '8px',
};

export const notif: SxProps = {
  background: yellow1,
  display: 'flex',
  borderRadius: '30px',
  justifyContent: 'center',
  alignItems: 'center',
  width: 'fit-content',
  height: '20px',
  p: '2px 8px 0 8px',
};

export const notifText: SxProps = {
  fontSize: '12px',
  fontWeight: '700',
  fontFamily: 'Yelo',
  lineHeight: 1,
};

export const menuBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};
